import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/aditivoApostila'

class AditivoApostilaApiClient {
	async criarAditivoApostila(objParam) {
		return await axios.post(URL_PATH, objParam)
	}
	async buscarDadosGeraisAditivoApostila(idAditivoApostila) {
		return await axios.get(`${URL_PATH}/${idAditivoApostila}`)
	}
	async salvarDadosGeraisAditivoApostila({ idAditivoApostila, body }) {
		return await axios.put(`${URL_PATH}/${idAditivoApostila}`, body)
	}
	async salvarQuantidadeAcrescimoSupressao(objSalvar, idAditivoApostila) {
		return axios.put(`${URL_PATH}/${idAditivoApostila}/acrescimoSupressao`, objSalvar)
	}
	async efetivarAditivoApostila({ idAditivoApostila, body }) {
		return await axios.put(`${URL_PATH}/${idAditivoApostila}/efetivar`, body)
	}
	async buscarFornecedoresPorItem(idItemAditivoApostila) {
		return await axios.get(`${URL_PATH}/item/${idItemAditivoApostila}/buscarFornecedores`)
	}
	async alterarFornecedorDoItem({ idItemAditivoApostila, body }) {
		return await axios.put(`${URL_PATH}/item/${idItemAditivoApostila}/alterarFornecedor`, body)
	}
	async cancelarAcrescimoSupressao(idAditivoApostila) {
		return axios.put(`${URL_PATH}/${idAditivoApostila}/cancelarAcrescimoSupressao`)
	}
	async buscarHistoricoAditivoApostila(idAta, paginacao) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAta}/historico`,
			filters: { idAta: idAta },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(URL)
	}
	async existeDocumentosEnvioPncp(idAditivoApostila) {
		return await axios.get(`${URL_PATH}/${idAditivoApostila}/existeDocumentosEnvioPncp`)
	}
}

export default new AditivoApostilaApiClient()
